/** Apply a price overlay update while preserving product existence and unrelated prices. */
export function withProductPrice(
  prices: Partial<Record<string, string>>,
  productId: number,
  amount: string | null,
): Partial<Record<string, string>> {
  const key = String(productId);
  if (amount === null) {
    const { [key]: _removed, ...remaining } = prices;
    return remaining;
  }
  return { ...prices, [key]: amount };
}
